<main class="login-page">
  <!-- Decorative background: curved waves and an oversized, faded PGC logo behind the card. -->
  <svg class="bg-waves" viewBox="0 0 1440 900" preserveAspectRatio="none" aria-hidden="true">
    <path d="M0 620 C 260 540, 520 700, 800 640 S 1260 520, 1440 600 L1440 900 L0 900 Z" />
    <path d="M0 720 C 300 660, 620 800, 900 740 S 1280 660, 1440 720 L1440 900 L0 900 Z" />
  </svg>
  <img class="watermark" src="pgc-logo.png" alt="" aria-hidden="true" />

  <section class="login-intro" aria-label="EBP introduction">
    <a class="brand" routerLink="/login" aria-label="EBP sign in">
      <span class="brand-mark" aria-hidden="true"><img src="pgc-logo.png" alt="" /></span>
      <span>Enterprise Business Platform </span>
    </a>

    <div class="intro-copy">
      <h1>
        Welcome to your
        <span class="gradient-word">workspace.</span>
      </h1>
      <p class="subtitle">Sign in to raise requests and review your approvals.</p>
    </div>

    <!-- Workflow dashboard illustration: Request, Review, Approve, Complete. Purely decorative. -->
    <div class="scene" aria-hidden="true">
      <div class="dash-card">
        <div class="dash-top">
          <span class="dots"><i></i><i></i><i></i></span>
          <span class="dash-title"><img src="pgc-logo.png" alt="" /> EBP Workflow</span>
        </div>

        <div class="dash-body">
          <div class="dash-side"><i class="active"></i><i></i><i></i><i></i><i></i><i></i></div>

          <div class="dash-main">
            <div class="stages">
              <div class="stage done">
                <span class="node"><mat-icon>check</mat-icon></span>
                <small>Request</small>
              </div>
              <div class="stage done">
                <span class="node"><mat-icon>check</mat-icon></span>
                <small>Review</small>
              </div>
              <div class="stage done">
                <span class="node"><mat-icon>check</mat-icon></span>
                <small>Approve</small>
              </div>
              <div class="stage current">
                <span class="node"><span class="pulse"></span></span>
                <small>Complete</small>
              </div>
              <span class="track"></span>
            </div>

            <div class="rows">
              <div class="row">
                <span class="bar long"></span><span class="status in-approval">In Approval</span>
              </div>
              <div class="row">
                <span class="bar"></span><span class="status on-hold">On Hold</span>
              </div>
              <div class="row">
                <span class="bar long"></span><span class="status returned">Returned</span>
              </div>
              <div class="row">
                <span class="bar"></span><span class="status approved">Approved</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span class="float doc-chip"><mat-icon>description</mat-icon></span>
      <span class="float bell-chip"
        ><mat-icon>notifications</mat-icon><span class="ping"></span
      ></span>
      <span class="float logo-chip"><img src="pgc-logo.png" alt="" /></span>
    </div>

    <p class="intro-footnote">CAPEX, MDM and more in one place.</p>
  </section>

  <section class="login-panel">
    <mat-card appearance="outlined" class="login-card">
      <mat-card-content>
        <div class="mobile-brand brand">
          <span class="brand-mark" aria-hidden="true"><img src="pgc-logo.png" alt="" /></span>
          <span>EBP </span>
        </div>

        <h2>Sign in</h2>
        <p class="card-description">Sign in with your account or with Microsoft.</p>

        @if (personas.length) {
          <div class="quick-personas-section">
            <span class="quick-title">Test accounts (development only):</span>
            <div class="persona-buttons">
              @for (p of personas; track p.username) {
                <button
                  mat-stroked-button
                  type="button"
                  class="persona-btn"
                  (click)="signInAs(p)"
                  [disabled]="busy()"
                >
                  <mat-icon aria-hidden="true">{{ p.icon }}</mat-icon>
                  <span>{{ p.label }}</span>
                </button>
              }
            </div>
          </div>
          <div class="divider"><span>or sign in manually</span></div>
        }

        <form (ngSubmit)="submit(usernameInput.value, passwordInput.value)" novalidate>
          <mat-form-field appearance="outline">
            <mat-label>Username or Email</mat-label>
            <input
              matInput
              type="text"
              name="username"
              #usernameInput
              autocomplete="username"
              required
            />
            <mat-icon matSuffix aria-hidden="true">account_circle</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input
              matInput
              [type]="showPassword() ? 'text' : 'password'"
              name="password"
              #passwordInput
              autocomplete="current-password"
              required
            />
            <button
              mat-icon-button
              matSuffix
              type="button"
              class="password-toggle"
              [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
              [attr.aria-pressed]="showPassword()"
              (click)="showPassword.set(!showPassword())"
            >
              <mat-icon aria-hidden="true">{{ showPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>

          @if (errorMessage()) {
            <p class="error-message" role="alert">{{ errorMessage() }}</p>
          }

          <button
            mat-flat-button
            color="primary"
            class="submit-button"
            type="submit"
            [disabled]="busy()"
          >
            <span>Sign in to EBP</span>
            <mat-icon aria-hidden="true">arrow_forward</mat-icon>
          </button>
        </form>

        <div class="divider"><span>or</span></div>

        <button
          mat-stroked-button
          type="button"
          class="microsoft-button"
          (click)="microsoftSignIn()"
        >
          <span class="microsoft-mark"><i></i><i></i><i></i><i></i></span>
          <span>Sign in with Microsoft</span>
        </button>
      </mat-card-content>
    </mat-card>
  </section>
</main>
